t = require('app/scripts/views/internal/teacup-with-helpers')('member_cards_card')

module.exports = ->
  t.div '.js-card'
  t.p '.list-card-position.quiet', ->
    t.mustacheBlock 'showBoard', ->
      t.format 'in-listname-on-boardname', { listName: t.mustacheVar('listName'), boardName: t.mustacheVar('boardName') }
    t.mustacheBlockInverted 'showBoard', ->
      t.format 'in-listname', { listName: t.mustacheVar('listName') }
